module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('person', {
    attrs: {
      "counselor-id": _vm.counselorId,
      "loan-type-arr": _vm.loanTypeArr
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('p', {
    staticClass: "articles-top clearfix"
  }, [_c('span', {
    staticClass: "release-date"
  }, [_vm._v("发布日期：" + _vm._s(_vm.article.auditDate))]), _vm._v(" "), _c('span', {
    staticClass: "article-type"
  }, [_vm._v("文章类型：" + _vm._s(_vm.article.copyright))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })]), _vm._v(" "), _c('br')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-51d081a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/article.vue
// module id = 602
// module chunks = 1